import {List, Spin, Pagination} from "antd";
import NewsDetail from './news_detail';
import {changZykStoryCount, getZykSotryList, getAnalyze} from '../../actions';
import {connect} from "react-redux";
import React, {Component} from "react";
import Constant from "./constant.js"
import './list.css';
import {HEADER_HEIGHT} from "../../constants";
import {Link} from 'react-router-dom'
import $ from 'jquery'
import {applicationName} from "../../utils";

class ListComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: [],
            storyInfo: {},//点击的条目的id
            show: "list",//content/list
            count: 0,
            size: Constant.configPagesize,
            start: 1,
            loading: false,
            height: applicationName() == 'pms' ? window.innerHeight - HEADER_HEIGHT - 172 : window.innerHeight - HEADER_HEIGHT - 272,
        };
        window.addEventListener('resize', this.resize.bind(this));
    }

    resize(){
        this.setState({
            height: applicationName() == 'pms' ? window.innerHeight - HEADER_HEIGHT - 172 : window.innerHeight - HEADER_HEIGHT - 272,
        });
    }

    // 在组件即将被挂载到页面的时刻执行
    componentWillMount() {
        this.setState({
            loading: true,
        })
        let onlyMe = 1;
        if (this.props.onlyMe) {
            onlyMe = 0
        }
        let param = {
            "query": this.props.searchText,
            "isAll": onlyMe,
            "start": this.state.start,
            "size": this.state.size
        };
        //请求后台获取稿件列表数据
        getZykSotryList(param, this.updateListNewsData.bind(this));
    }

    updateListNewsData(result) {

        //处理前台分页数据
        this.props.changZykStoryCount(result.count);
        let resultData = result.data;
        this.setState({
            data: resultData,
            loading: false,
            count: result.count
        });

    }


    /**
     * 分词在页面高亮显示；
     * @param data
     */
    lightAnayWorldInList(data) {
        //按照优先级排序
        if(data&&data.length>0){
            let listData = data.sort(function (a, b) {
                return b.length - a.length
            });
            // for(var i=0;i<data.length;i++){
            //定义正则表达式对象  array[i]是关键字   "g"是指全局范围
            let a = new RegExp(listData.join("|"), "g");
            $(".story-title").each(function () {
                var html = $(this)[0].getAttribute('title')
                html = html.replace(a, function (item) {
                    return "<span style='color:#F00'>" + item + "</span>"
                });
                $(this).html(html);
            });
        }
    }

    componentWillReceiveProps(newProps, nextContext) {
        if (newProps.tableKey === 1) {
            this.setState({
                loading: true,
                start: 1,
            })
            let onlyMe = 1;
            if (newProps.onlyMe) {
                onlyMe = 0
            }
            let param = {
                "query": newProps.searchText,
                "isAll": onlyMe,
                "start": 1,
                "size": this.state.size

            };
            //请求后台获取稿件列表数据
            getZykSotryList(param, this.updateListNewsData.bind(this));
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.tableKey==1) {
            console.info("story_list");
            //分词处理，分词高亮显示；
            if (this.props.searchText) {
                let param = {
                    str: this.props.searchText
                }
                //请求后台获取分词数据
                getAnalyze(param, this.lightAnayWorldInList.bind(this));
            }else {
                $(".content-header").each(function () {
                    if ($(this).find('span')[0] && $(this).find('span')[0].style) {
                        $(this).find('span')[0].style.color = '#000';
                    }
                });
            }
        }
    }

    getZykSotryPageList(page, size) {

        this.setState({
            loading: true,
        })

        let onlyMe = 1;
        if (this.props.onlyMe) {
            onlyMe = 0
        }

        this.setState({
            start: page
        })

        let param = {
            "query": this.props.searchText,
            "isAll": onlyMe,
            "start": page,
            "size": size
        };
        //请求后台获取稿件列表数据
        getZykSotryList(param, this.updateListNewsData.bind(this));
    }

    //页面state或props发生变化时执行
    render() {
        let height = 0;
        if (this.props.match && this.props.match.params && this.props.match.params.height) {
            height = this.props.match.params.height - HEADER_HEIGHT - 172;
            ;
        } else {
            height = this.state.height;
        }
        return (
            <div>
                <Spin spinning={this.state.loading}>
                    <div className='storyListDiv' style={{
                        display: (this.state.show === "list" ? "block" : "none"),
                        height: height + 'px', overflowX: "hidden"
                    }}>
                            <List
                                style={{display:'flex'}}
                                itemLayout="vertical"
                                size="large"
                                dataSource={this.state.data}
                                renderItem={item => (
                                    <List.Item
                                        key={item.ZykStory_id}
                                        actions={[
                                            <p className={"content-box-" + applicationName()} title={Constant.getDataSource(item.ZykStory_dataSource)}>来源: {Constant.getDataSource(item.ZykStory_dataSource)}</p>,
                                            <p className={"content-box-" + applicationName()} title={item.ZykStory_submitDate}>日期: {item.ZykStory_submitDate}</p>
                                        ]}
                                    >
                                        <List.Item.Meta
                                            title={<Link
                                                to={"/zyknewsDetail/" + item.ZykStory_id + "/" + item.ZykStory_resourceType}
                                                target={'_blank'}><span title={item.ZykStory_title}
                                                                        className={'story-title title-' + applicationName()}
                                            >{item.ZykStory_title}</span></Link>}
                                        />
                                        <div className={"storyContent content-box-" + applicationName()}
                                             title={item.content}>{item.content}</div>
                                    </List.Item>
                                )}
                            />
                    </div>
                    <div className='pageTables' style={{
                        display: (this.state.show === "list" ? "block" : "none")
                    }}>
                        <Pagination showLessItems={true} current={this.state.start} total={this.state.count}
                                    defaultPageSize={this.state.size} defaultCurrent={1}
                                    onChange={(page, pageSize) => {
                                        this.getZykSotryPageList(page, pageSize)
                                    }} onShowSizeChange={(page, pageSize) => {
                            this.getZykSotryPageList(page, pageSize)
                        }}/>
                    </div>
                </Spin>
            </div>
        )
    }
}


function mapStateToProps(state) {
    return {
        searchText: state.zykReducer.searchText,
        onlyMe: state.zykReducer.onlyMe,
        tableKey: state.zykReducer.tableKey,
        doSearch: state.zykReducer.doSearch
    }
}

function mapStateToMethod(dispatch) {
    return {
        changZykStoryCount: function (zykStoryCount) {
            return dispatch(changZykStoryCount(zykStoryCount));
        }
    }
}

export default connect(mapStateToProps, mapStateToMethod)(ListComponent);